<template>
	<div class="grape" :style="grapestyle">
		<div class="boder">
			<div class="top">
				<el-row>
					<el-col :span="8">
						<div class="top_datetime">
							<span class="top_datetime_time">{{time}}</span>
							<span class="top_datetime_date">{{date}}</span>
						</div>
					</el-col>
					<el-col :span="8">
						<h1 class="top-h1">金华特色农业种植监测和溯源技术平台</h1>
					</el-col>
					<el-col :span="8">
						<div class="top_unit">
							<p>研发单位：金华市农业农村大数据发展中心
								<br />
								合作单位：浙江创基电子有限公司
							</p>
						</div>
						<div class="top-iconbig">
							<img @click="toggleFullScreen" :src="togglesrc" alt="" />
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="content">
				<el-row>
					<el-col :span="5.5">
						<div class="content-left">
							<div class="content-boder">
								<h3>气象站监测</h3>
								<monitor />
							</div>

							<div class="content-boder">
								<h3>气象站预警</h3>
								<earlywarning />
							</div>
							<div class="content-boder">
								<h3>水肥灌溉记录</h3>
								<waterfertilizer />
							</div>
						</div>
					</el-col>
					<el-col :span="13">
						<div class="content-mid">
							<div height="80px">
								<three />
							</div>
							<div height="800px">
								<midmap />
							</div>
							<div>
								<div class="model_bottom">
									<div class="bottom_title">
										<div class="bottom_title_item"
											:class="{ bottom_item_active: buttonactiveIndex === 1 }"
											@click="addbuttonActive(1);router.replace('/model')">
											葡萄生长模型
										</div>
										<div class="bottom_title_item"
											:class="{ bottom_item_active: buttonactiveIndex === 0 }"
											@click="addbuttonActive(0)">
											种植监测
										</div>
										<div class="bottom_title_item"
											:class="{ bottom_item_active: buttonactiveIndex === 2 }"
											@click="addbuttonActive(2)">
											农产品溯源
										</div>
									</div>
								</div>

							</div>
						</div>
					</el-col>
					<el-col :span="5.5">
						<div class="content-right">
							<div class="content-boder">
								<h3>果实转色期</h3>
								<phenological />
							</div>

							<div class="content-boder">
								<h3>农场监控</h3>
								<ezuikit />
							</div>
							<div class="content-boder">
								<h3>设备管控</h3>
								<management />
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>

	</div>
</template>
<script setup>
	import {
		ref,
		defineComponent,
		onMounted,
		onUnmounted,
		watch
	} from "vue";
	import {
		useRouter
	} from "vue-router";
	const router = useRouter();
	import {
		Gettoken
	} from '../../api/api.js';
	import mitt from '../../utils/bus.js'
	import big from '@/assets/home/big.png'
	import min from '@/assets/home/min.png'


	import {
		useStore
	} from 'vuex';

	const store = useStore();


	Gettoken().then(res => {
		mitt.emit('Gettoken', res.data);
	}).catch(err => {
		console.log(err)
	})
	import waterfertilizer from "../home/waterfertilizer/index.vue";
	import monitor from "../home/monitor/index.vue";
	import ezuikit from "../home/ezuikit/index.vue";
	import three from "../home/three/index.vue";
	import earlywarning from "../home/earlywarning/index.vue";
	import phenological from "../home/phenological/index.vue";
	import midmap from "../home/mid-map/index.vue";

	import management from "../home/management/index.vue";
	let date = ref("");
	let time = ref("");
	let grapestyle = ref();

	let isfullscreen = ref(false)
    let togglesrc = ref(big)
	
	if(store.state.isFullscreen){
		 togglesrc.value = min;
	}
	else{
		 togglesrc.value = big;
	}
	// const defaultwindowWidth=window.innerWidth;
	// const defaultwindowheight=window.innerHeight;

	const resize = () => {
		// 获取浏览器窗口的宽度
		const windowWidth = window.innerWidth;
		// if(defaultwindowWidth==windowWidth){
		// 	grapestyle.value = `transform:scale(${defaultwindowheight/1080});`
		// }
		// else{
		// 	grapestyle.value = `transform:scale(${windowWidth/1920});`
		// }
		grapestyle.value = `transform:scale(${windowWidth/1920});`

	}
	// 在组件挂载后添加事件监听器
	onMounted(() => {
		// 初始化时调用一次 resize 函数，确保初始样式正确
		resize();
		// 监听窗口大小变化，当窗口大小变化时执行 resize 函数
		window.addEventListener('resize', resize);
		// document.addEventListener('keydown', handleKeyPress);
	});

	// function handleKeyPress(event) {
	// 	// 如果按下的是F11键
	// 	if (event.key === 'F11') {

	// 		// 检查浏览器是否支持全屏API
	// 		if (document.fullscreenEnabled) {
	// 			// 如果当前不是全屏状态，则进入全屏，否则退出全屏
	// 			if (!document.fullscreenElement) {
	// 				document.documentElement.requestFullscreen(); // 进入全屏
	// 				window.parent.postMessage({ type: "changeFullScreen", data: true }, "*");
	// 				togglesrc.value = min

	// 			} else {
	// 				document.exitFullscreen(); // 退出全屏
	// 				window.parent.postMessage({ type: "changeFullScreen", data: false }, "*");
	// 				togglesrc.value = big
	// 			}
	// 		} else {
	// 			console.error('浏览器不支持全屏功能');
	// 		}
	// 	}
	// }

	function toggleFullScreen() {

		window.parent.postMessage({
			type: "changeFullScreen",
			data: !store.state.isFullscreen
		}, "*");
	}

	window.addEventListener('message', function(event) {
		if (event.data && event.data.type === "changeFullScreen") {
			togglesrc.value = event.data.data ? min : big;
			store.dispatch('toggleFullscreen', event.data.data);
		}
	});

	let buttonactiveIndex = ref(0);

	function addbuttonActive(e) {
		buttonactiveIndex.value = e;
		if (e == 2) {
			window.parent.postMessage({
				type: "changeTab",
				data: "trace"
			}, "*");
		}
	}
	mitt.on('Changerouter', (data) => {
		buttonactiveIndex.value = data
	})

	const interval = setInterval(() => {
		const days = ['日', '一', '二', '三', '四', '五', '六'];
		const dt = new Date();
		var y = dt.getFullYear();
		var mt = dt.getMonth() + 1;
		var day = dt.getDate();
		var h = dt.getHours(); //获取时
		var m = dt.getMinutes(); //获取分
		var s = dt.getSeconds(); //获取秒
		const dayIndex = dt.getDay();
		date.value = y + "年" + mt + "月" + day + "日" + " " + "星期" + days[dayIndex];
		time.value = h + ":" + m + ":" + s;
	}, 1000);
	onUnmounted(() => {
		window.removeEventListener('resize', resize);
		// document.removeEventListener('keydown', handleKeyPress);
		clearInterval(interval);
	})
</script>
<style scoped lang="scss">
	.grape {
		width: 1920px;
		height: 1080px;
		// overflow: hidden;
		background-image: url("../../assets/home/backcolor.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		transform-origin: top left;

	}

	.boder {
		width: 1920px;
		height: 1080px;
		background-image: url("../../assets/home/top.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;

		.top {
			height: 70px;
			width: 100%;
			position: relative;

			.top_datetime {
				line-height: 70px;
				color: #c9ffff;
				padding-top: 5px;

				.top_datetime_time {
					font-size: 16px;
					padding-left: 30px;
				}

				.top_datetime_date {
					font-size: 16px;
					padding-left: 10px;
				}
			}

			.top-h1 {
				text-align: center;
				line-height: 70px;
				color: #c9ffff;
			}

			.top_unit {
				color: #a1d1d0;
				position: absolute;
				top: 25px;
				right: 100px;

			}

			.top-iconbig {
				padding-left: 570px;
				line-height: 70px;
				padding-top: 10px;
			}
		}

		.content {
			width: 99%;
			margin: 0 auto;
			height: 970px;

			.content-boder {
				margin-top: 10px;
				width: 420px;
				height: 310px;
				background-image: url("../../assets/home/title_min.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				color: white;

				h3 {

					padding-top: 3px;
					text-align: center;
					height: 27px;
					line-height: 27px;
					color: #2dffd0;
				}
			}

			.content-mid {

				.model_bottom {
					margin-top: 35px;

					.bottom_title {
						width: 50%;
						display: flex;
						font-size: 14px;
						margin: 0 auto;
						margin-top: 20px;
						justify-content: space-between;
						color: #00a580;

						.bottom_title_item {
							margin-left: 20px;
							text-align: center;
							width: 142px;
							line-height: 30px;
							height: 20px;
							background-image: url('../../assets/home/mid-bot-defalt.png');
							padding: 5px;
							background-size: 100% 100%;
						}

						.bottom_item_active {

							width: 185px;
							background-image: url('../../assets/home/mid-bot-hover.png');
							color: white;
							background-size: 100% 100%;
						}
					}

				}
			}

			.content-left {
				padding-left: 15px;
			}

		}

	}
</style>